import { render, staticRenderFns } from "./PartTwo.vue?vue&type=template&id=0539357e&scoped=true"
import script from "./PartTwo.vue?vue&type=script&lang=js"
export * from "./PartTwo.vue?vue&type=script&lang=js"
import style0 from "./PartTwo.vue?vue&type=style&index=0&id=0539357e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539357e",
  null
  
)

export default component.exports